import _ from "lodash";

// constants
import { REGULAR } from "Constants/stringConstants";

// utils
import {
  getIsLearningCoursesEnabled,
  getIsSubjectBasedGradingEnabled,
} from "Teacher/routes/LearningCourses/modules/Utils";
import { getFieldValue } from "Assessments/modules/Utils";

// graphql helpers
import {
  getAssessmentCourseDetailsFromCache,
  getAssessmentDetailsFromCache,
  getAssessmentLearningCourseDetailsFromCache,
} from "Assessments/modules/AssessmentGraphqlHelpers";

export const getGradeScaleQueryVariables = params => {
  const {
    curriculumProgramId,
    assessmentId,
    learningCourseId,
    academicYearId,
    courseId,
  } = params;

  const isSubjectBasedGradingEnabled =
    !getIsLearningCoursesEnabled() || getIsSubjectBasedGradingEnabled();

  const assessmentDetails = getAssessmentDetailsFromCache({
    id: assessmentId,
    collaboratorsFilter: {
      userAcademicYearId: academicYearId,
    },
  });

  const academicTermIds = _.compact([
    _.get(assessmentDetails, "academicTerm.id", null),
  ]);

  const subjectIds = getFieldValue({
    fields: assessmentDetails?.allFields,
    uid: "subjects",
  });

  const entityDetailFilters = [];

  if (isSubjectBasedGradingEnabled) {
    let courseDetails = getAssessmentCourseDetailsFromCache({
      id: courseId,
    });

    if (getIsLearningCoursesEnabled()) {
      courseDetails = getAssessmentLearningCourseDetailsFromCache({
        id: learningCourseId,
      });
    }

    const gradeId = _.get(courseDetails, "primaryGrade.id");

    if (!_.isEmpty(gradeId) && !_.isEmpty(academicTermIds)) {
      _.forEach(subjectIds, subjectId => {
        entityDetailFilters.push({
          subjectId,
          gradeId,
          academicTermIds,
        });
      });
    }
  } else {
    if (!_.isEmpty(academicTermIds) && !_.isEmpty(learningCourseId)) {
      entityDetailFilters.push({
        academicTermIds,
        learningCourseId,
      });
    }
  }

  const entityType = isSubjectBasedGradingEnabled
    ? "SUBJECT_GRADE_MAP"
    : "LEARNING_COURSE";

  return {
    id: curriculumProgramId,
    gradeScaleFilters: {
      isArchived: false,
      types: [REGULAR],
      entityType,
      entityDetailFilters,
    },
    gradingSetupEntityFilters: {
      entityType,
      entityDetails: entityDetailFilters,
    },
  };
};
